export default "__VITE_ASSET__B0pTMld4__"